export const TERMS_AND_CONDITIONS = '20';
export const PRIVACY_POLICY = '16';
